import { useState, useRef } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { encodeFileBase64, getProfilePicture } from "../../utilities/Helpers";

import defaultIcon from '../../styles/images/default-player-icon.png';

const EditProfileModal = ({ profile, updateProfile }: { profile: Profile, updateProfile: (profile: Profile) => void }) => {
    const [editingProfile, setEditingProfile] = useState(false);
    const handleClose = () => setEditingProfile(false);

    const inputRef = useRef<HTMLInputElement>(null);
    const [username, setUsername] = useState<string>((profile) ? profile.name : '');
    const [preview, setPreview] = useState<string>(getProfilePicture(profile.address) ?? defaultIcon);
    const [file, setFile] = useState<File>();

    if (!profile) return <></>;

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (e.target.files && e.target.files.length > 0) {
            let image = e.target.files[0];
            setFile(image);
            encodeFileBase64(image).then(setPreview);
        }
    }

    const handleUpload = (e: React.FormEvent<HTMLElement>) => {
        e.preventDefault();
        inputRef.current?.click();
    };

    async function handleUpdateProfile(e: any) {
        e.preventDefault();
        if (!profile.address) return;

        const formData = new FormData();
        formData.append('address', profile.address);
        formData.append('name', username);
        if (file) {
            formData.append('picture', file);
        }

        let response = await ApiService.post('/account/update', formData, true);

        if (!response.success)
            throw new Error(`Failed to update: ${response.message}`);

        updateProfile(response.data);
        handleClose();
    }

    return (<>
        <button className="dg-btn dg-btn-primary text-light px-3 pt-0 pb-1" onClick={() => setEditingProfile(true)}>
            Edit
        </button>
        <Modal
            show={editingProfile}
            onHide={handleClose}
            dialogClassName="modal-90w"
            className="dg-modal"
        >
            <Form onSubmit={handleUpdateProfile}>
                <Modal.Header closeButton closeVariant="white">
                    <Modal.Title>Edit Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <h5>Darknet Info</h5>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="editProfileUsername">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" placeholder="Username" defaultValue={profile?.name} onChange={(e) => setUsername(e.target.value)} />
                            </Form.Group>
                            <span>Profile Picture</span>
                            <Form.Group className="mt-3 me-4 mb-3" controlId="editProfileImage">
                                <button onClick={handleUpload} className="dg-btn dg-btn-primary py-2 px-3 text-light">Upload</button>
                                <input title="pfp" ref={inputRef} className="d-none" type="file" accept="image/png,image/jpg,image/jpeg,image/gif" onChange={handleFileChange} />
                            </Form.Group>
                        </Col>
                        <Col>

                            <Row>
                                <Col className="pt-4 ps-5">
                                    <img src={preview ?? defaultIcon} alt="pfp" height={128} width={128} />
                                </Col>
                                <Col>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* 
                    <hr />
                    <Row>
                        <Col>
                            <h5>Wallet Connections</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <i>Coming soon</i>
                        </Col>
                    </Row>
                    */}
                </Modal.Body>
                <Modal.Footer className="">
                    <Col>
                        <button
                            className="dg-btn dg-btn-secondary dg-btn-block"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </Col>
                    <Col>
                        <button
                            className="dg-btn dg-btn-primary dg-btn-block text-light"
                            onClick={handleUpdateProfile}
                        >
                            Save Changes
                        </button>
                    </Col>
                </Modal.Footer>
            </Form>
        </Modal>
    </>);
}

export default EditProfileModal;